module.exports = __webpack_public_path__ + "static/media/student-name.abe894c2.png";